export enum TransactionAmountSettings {
  Fixed,
  Variable
}
